export default {
    methods: {
        getResolution: function() {
            // Retina 3x
            if (window.devicePixelRatio >= 3) {
                return '@3x'
            }
            // Retina 2x
            if (window.devicePixelRatio >= 2) {
                return '@2x'
            }
            // Not Retina
            return ''
        },
    },
}
